(function() {
    'use strict';

    angular.module('product')
        .controller('ProductCreateController', ProductCreateController);

    ProductCreateController.$inject = ['$state', '$timeout', 'productDataSrvc', 'notificationSrvc', 'productMessagesConst', 'categoryDataSrvc', 'productCountryConst', 'appliancesDataSrvc', 'productParameterDataSrvc', 'packageDataSrvc', 'formatDataSrvc', 'fileDataSrvc', 'productQuantitySrvc', 'lodashService', 'productQuantityMessagesConst', 'pageDataSrvc', 'productOptionGroupDataSrvc', 'productOptionDataSrvc', '$uibModal', 'productoptionpricePermissionsConst', 'checkModelPermissionsSrvc', 'productQuantityPermissionsConst', 'productOptionGroupPermissionsConst', 'productOptionPermissionsConst', 'errorNotificationSrvc'];

    function ProductCreateController($state, $timeout, productDataSrvc, notificationSrvc, productMessagesConst, categoryDataSrvc, productCountryConst, appliancesDataSrvc, productParameterDataSrvc, packageDataSrvc, formatDataSrvc, fileDataSrvc, productQuantitySrvc, lodashService, productQuantityMessagesConst, pageDataSrvc, productOptionGroupDataSrvc, productOptionDataSrvc, $uibModal, productoptionpricePermissionsConst, checkModelPermissionsSrvc, productQuantityPermissionsConst, productOptionGroupPermissionsConst, productOptionPermissionsConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            name_en: [],
            name_de: [],
            name_cpde: [],
            name_cpen: [],
            short_description_pl: [],
            short_description_en: [],
            short_description_de: [],
            short_description_cpde: [],
            short_description_cpen: [],
            description_pl: [],
            description_en: [],
            description_de: [],
            description_cpde: [],
            description_cpen: [],
            title_seo_pl: [],
            title_seo_de: [],
            title_seo_en: [],
            title_seo_cpde: [],
            title_seo_cpen: [],
            description_seo_pl: [],
            description_seo_de: [],
            description_seo_en: [],
            description_seo_cpde: [],
            description_seo_cpen: [],
            keywords_seo_pl: [],
            keywords_seo_de: [],
            keywords_seo_en: [],
            keywords_seo_cpde: [],
            keywords_seo_cpen: [],
            categories: [],
            appliances: [],
            parameters: [],
            group_options: [],
            options: [],
            package: [],
            horizontal: [],
            is_published: [],
            is_popular: [],
            date_from: [],
            date_to: [],
            deadline: [],
            bleed: [],
            text_margin: [],
            frozen_price: [],
            imposition: [],
            exclusive_sheet: [],
            from_warehouse: [],
            unit_weight: [],
            image: [],
            available_in_countries: [],
            materials_pl: [],
            materials_en: [],
            materials_de: [],
            materials_cpde: [],
            materials_cpen: [],
            nonFieldErrors: [],
            page: [],
            kind: [],
            option_group_for_page_count: [],
            option_group_for_cover_page_count: [],
            option_group_for_deadline: [],
            deadline_time: [],
            is_available_on_allegro: []
        };

        self.productData = {
            name_pl: '',
            name_en: '',
            name_de: '',
            name_cpde: '',
            name_cpen: '',
            short_description_pl: '',
            short_description_en: '',
            short_description_de: '',
            short_description_cpde: '',
            short_description_cpen: '',
            description_pl: '',
            description_en: '',
            description_de: '',
            description_cpde: '',
            description_cpen: '',
            title_seo_pl: '',
            title_seo_de: '',
            title_seo_en: '',
            title_seo_cpde: '',
            title_seo_cpen: '',
            description_seo_pl: null,
            description_seo_de: null,
            description_seo_en: null,
            description_seo_cpde: null,
            description_seo_cpen: null,
            keywords_seo_pl: null,
            keywords_seo_de: null,
            keywords_seo_en: null,
            keywords_seo_cpde: null,
            keywords_seo_cpen: null,
            categories: [],
            appliances: [],
            parameters: [],
            group_options: [],
            options: [],
            package: '',
            available_in_countries: [],
            date_from: undefined,
            date_to: undefined,
            deadline: 0,
            bleed: 3.0,
            text_margin: 0.0,
            unit_weight: 0.0,
            horizontal: false,
            is_published: true,
            is_popular: false,
            frozen_price: false,
            imposition: false,
            exclusive_sheet: false,
            from_warehouse: false,
            image: undefined,
            materials_pl: undefined,
            materials_en: undefined,
            materials_de: undefined,
            materials_cpde: undefined,
            materials_cpen: undefined,
            page: null,
            quantities: [],
            option_prices: [],
            kind: '',
            option_group_for_page_count: null,
            option_group_for_cover_page_count: null,
            option_group_for_deadline: null,
            deadline_time: null,
            is_available_on_allegro: false
        };
        self.countryList = productCountryConst;
        self.kindOptions = [];
        self.categoriesList = [];
        self.appliancesList = [];
        self.productParametersList = [];
        self.productGroupOptionsList = [];
        self.packagesList = [];
        self.formatsList = [];
        self.materialsFilesList = [];
        self.pagesList = [];
        self.optionsList = [];
        self.groupOptionsForPageNum = [];

        self.extraActions = [{
            class: 'btn btn-success btn-xs',
            iconClass: 'fa fa-cog',
            onClick: onOptionPricesInQuantityDisplay,
            title: 'Do realizacji'
        }];

        // ngModel for duallist options
        self.selectedParametersPks = [];
        self.selectedGroupOptionsPks = [];

        // ngModel for duallist subOptions
        self.selectedParametersOptionsPks = [];

        self.createProduct = createProduct;
        self.cleanErrors = cleanErrors;

        self.quantityModelPermissions = productQuantityPermissionsConst;
        self.hasQuantityViewPermission = hasQuantityViewPermission;
        self.onQuantityDelete = onQuantityDelete;

        self.quantityCols = [{
            title: 'Nakład',
            value: 'quantity',
            type: 'number',
            required: true,
            minValue: 1,
            isEditable: true
        }, {
            title: 'Nakład widoczny',
            value: 'display_quantity',
            type: 'number',
            required: true,
            minValue: 1,
            isEditable: true
        }, {
            title: 'Cena',
            value: 'price',
            type: 'number',
            required: true,
            minValue: 0,
            isEditable: true
        }, {
            title: 'Dni realizacji',
            value: 'realization_days',
            type: 'number',
            required: false,
            minValue: 0,
            isEditable: true
        }];

        self.productGroupOptionsCols = [{
            title: 'ID',
            value: 'group_option',
            type: 'text'
        }, {
            title: 'Nazwa',
            value: 'group_option_name',
            type: 'text'
        }];
        self.productGroupSubOptionsCols = [{
            title: 'ID',
            value: 'option',
            type: 'text'
        }, {
            title: 'Nazwa',
            value: 'option_name',
            type: 'text'
        }];

        self.hasProductOptionGroupViewPermission = hasProductOptionGroupViewPermission;
        self.productOptionGroupModelPermissions = productOptionGroupPermissionsConst;
        self.productOptionPermissions = productOptionPermissionsConst;

        self.onOptionsGroupAdd = onOptionsGroupAdd;
        self.onOptionsGroupRemove = onOptionsGroupRemove;
        self.onOptionsGroupReorder = onOptionsGroupReorder;
        self.onOptionsGroupOptionsAdd = onOptionsGroupOptionsAdd;
        self.onOptionsGroupOptionsRemove = onOptionsGroupOptionsRemove;
        self.onOptionsGroupOptionsReorder = onOptionsGroupOptionsReorder;

        self.onOptionPricesByQuantityDisplay = onOptionPricesByQuantityDisplay;
        self.onOptionPricesInQuantityDisplay = onOptionPricesInQuantityDisplay;

        self.onFilesSearch = onFilesSearch;
        self.onProductOptionsChange = onProductOptionsChange;

        activate();

        function activate() {
            getCategories();
            getAppliances();
            getProductParameters();
            getGroupOptions();
            getPackages();
            getFormats();
            getFiles();
            getPages();
            getOptions();
            getKindOptions();
        }

        function getCategories() {
            return categoryDataSrvc.productParents()
                .$promise.then(function(response) {
                    self.categoriesList = response;
                    return response;
                });
        }

        function getAppliances() {
            return appliancesDataSrvc.productAppliances()
                .$promise.then(function(response) {
                    self.appliancesList = response;
                    return response;
                });
        }

        function getProductParameters() {
            return productParameterDataSrvc.productParameters()
                .$promise.then(function(response) {
                    self.productParametersList = response;
                    return response;
                });
        }

        function getGroupOptions() {
            return productOptionGroupDataSrvc.productGroupOptions()
                .$promise.then(function(response) {
                    self.productGroupOptionsList = response;
                    self.groupOptionsForPageNum = getGroupOptionsForPageNum();
                    return response;
                });
        }

        function getPackages() {
            return packageDataSrvc.packageOptions()
                .$promise.then(function(response) {
                    self.packagesList = response;
                    return response;
                });
        }

        function getFormats() {
            return formatDataSrvc.formatsAsOptions()
                .$promise.then(function(response) {
                    self.formatsList = response;
                    for (var i = response.length - 1; i >= 0; i--) {
                        self.formatsList[i].name = self.formatsList[i].size_x + ' x ' + self.formatsList[i].size_y;
                    }
                    return response;
                });
        }

        function getFiles() {
            return fileDataSrvc.productMaterialsFiles().$promise.then(
                function(response) {
                    self.materialsFilesList = response.results;
                    return response;
                }
            );
        }

        function onFilesSearch(params) {
            if (!params) {
                params = {};
            }
            return fileDataSrvc.productMaterialsFiles(
                params
            ).$promise;
        }

        function getPages() {
            return pageDataSrvc.productPages()
                .$promise.then(function(response) {
                    self.pagesList = response;
                });
        }

        function getOptions() {
            return productOptionDataSrvc.productOptions()
                .$promise.then(function(response) {
                    self.optionsList = response;
                    self.groupOptionsForPageNum = getGroupOptionsForPageNum();
                });
        }

        function getKindOptions() {
            return productDataSrvc.kindOptions()
                .$promise.then(function (response) {
                    self.kindOptions = response;
                });
        }

        function createProduct() {
            // build request data from ngModel(s) for duallist
            self.productData.parameters = self.selectedParametersOptionsPks;

            return productDataSrvc.create(
                self.productData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", productMessagesConst.add);
                    $state.go('layout.product.list');
                    return response;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function hasQuantityViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                productQuantityPermissionsConst.view);
        }

        function onQuantityDelete(row) {
            return productQuantitySrvc.remove("ten nakład", row.pk,
                function(response) {
                    removeQuantityRow(row);
                    return response;
                },
                function(error) {
                    if (error.status === 404) {
                        removeQuantityRow(row);
                    }
                });
        }

        function removeQuantityRow(row) {
            notificationSrvc.notification("success", productQuantityMessagesConst.delete);
            lodashService.remove(self.quantityRows, { pk: row.pk });
        }

        function hasOptionPricesViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                productoptionpricePermissionsConst.view);
        }

        function onOptionPricesByQuantityDisplay(option) {
            if (!hasOptionPricesViewPermission()) {
                notificationSrvc.notification("error", productoptionpricePermissionsConst.view.errorMsg);
                return;
            }

            $uibModal.open({
                templateUrl: 'app/product/views/product-option-prices-by-quantity-create/product-option-prices-by-quantity-create.html',
                controller: 'ProductOptionPricesByQuantityCreate',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    currentOption: function() {
                        return option;
                    },
                    product: function() {
                        return self.productData;
                    }
                }
            }).result.then(
                function(result) {
                    // self.productData.quantities = result;
                    return result;
                }
            );
        }

        function onOptionPricesInQuantityDisplay(quantity) {
            if (!hasOptionPricesViewPermission()) {
                notificationSrvc.notification("error", productoptionpricePermissionsConst.view.errorMsg);
                return;
            }

            $uibModal.open({
                templateUrl: 'app/product/views/product-option-prices-in-quantity-create/product-option-prices-in-quantity-create.html',
                controller: 'ProductOptionPricesInQuantityCreate',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    currentQuantity: function() {
                        return quantity;
                    },
                    product: function() {
                        return self.productData;
                    },
                    options: function() {
                        return self.optionsList;
                    },
                    selectedGroups: function() {
                        return self.productData.group_options;
                    }
                }
            }).result.then(
                function(result) {
                    return result;
                }
            );
        }

        function hasProductOptionGroupViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                productOptionGroupPermissionsConst.view);
        }

        function onOptionsGroupAdd() {
            $uibModal.open({
                templateUrl: 'app/product/views/product-options-group-add-modal/product-options-group-add-modal.html',
                controller: 'ProductOptionsGroupAddModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    product: function() {
                        return self.productData;
                    },
                    optionsGroups: function() {
                        return lodashService.differenceWith(
                            self.productGroupOptionsList,
                            self.productData.group_options,
                            function(group, assignedGroup) {
                                return group.pk === assignedGroup.group_option;
                            }
                        );
                    }
                }
            }).result.then(
                function(results) {
                    angular.forEach(results, function(group) {
                        self.productData.group_options.push({
                            group_option: group.pk,
                            group_option_name: group.name,
                            options: []
                        });
                    });
                    self.groupOptionsForPageNum = getGroupOptionsForPageNum();
                    return results;
                }
            );
        }

        function onOptionsGroupRemove(row) {
            lodashService.remove(self.productData.group_options, function(group) {
                return group.group_option === row.group_option;
            });
            self.groupOptionsForPageNum = getGroupOptionsForPageNum();
        }

        function onOptionsGroupReorder(row, newPos) {
            var index = 1;
            angular.forEach(self.productData.group_options, function(group) {
                group.position = index;
                index++;
            });
        }

        function onOptionsGroupOptionsAdd(row) {
            $uibModal.open({
                templateUrl: 'app/product/views/product-options-group-options-add-modal/product-options-group-options-add-modal.html',
                controller: 'ProductOptionsGroupOptionsAddModalController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    group_option: function() {
                        return row;
                    },
                    options: function() {
                        var group = lodashService.find(self.productGroupOptionsList, function(grp) {
                            return grp.pk === row.group_option;
                        });

                        if (group) {
                            return lodashService.differenceWith(
                                group.product_options,
                                row.options,
                                function(option, assignedOption) {
                                    return option.pk === assignedOption.option;
                                }
                            );
                        } else {
                            return [];
                        }
                    }
                }
            }).result.then(
                function(results) {
                    angular.forEach(results.options, function(option) {
                        results.group_option.options.push({
                            option: option.pk,
                            option_name: option.label,
                            position: results.group_option.options.length
                        });
                    });
                    return results;
                }
            );
        }

        function onOptionsGroupOptionsRemove(group, row) {
            lodashService.remove(group.options, function(option) {
                return option.option === row.option;
            });
        }

        function onOptionsGroupOptionsReorder(row, newPos) {
            var index = 1;
            angular.forEach(parent.options, function(option) {
                option.position = index;
                index++;
            });
        }

        function getGroupOptionsForPageNum() {
            var selectedGroups = lodashService.flatMap(self.productData.group_options || [], 'group_option'),
                selectedOptionsGroups = lodashService.map(self.productData.options || [], function (option_pk) {
                    var option = lodashService.find(self.optionsList || [], { 'pk': option_pk });
                    if (option) {
                        return option.options_group
                    }
                }),
                allowedGroupsIds = lodashService.concat(selectedGroups, selectedOptionsGroups),
                allowedGroups = lodashService.sortBy(lodashService.filter(self.productGroupOptionsList || [], function (group) {
                    return lodashService.includes(allowedGroupsIds, group.pk);
                }), 'pk');
            return allowedGroups;
        }

        function onProductOptionsChange() {
            $timeout(function () {
                self.groupOptionsForPageNum = getGroupOptionsForPageNum();
            });
        }
    }
})();
